import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}

export const SITE = {
  name: "askFinz",
  domain: "askfinz.com",
  url: process.env.NEXT_PUBLIC_SITE_URL || "https://askfinz.com",
  app: process.env.NEXT_PUBLIC_MAIN_APP_URL || "https://askfinz.ai",
  account: process.env.NEXT_PUBLIC_ACCOUNT_APP_URL || "https://account.askfinz.ai",
  login: process.env.NEXT_PUBLIC_LOGIN_APP_URL || "https://login.askfinz.ai",
  legal: process.env.NEXT_PUBLIC_LEGAL_PAGES_URL || "https://askfinz.com/legal",
  email: "hello@askfinz.com",
  twitter: "@askfinz",
} as const;
